document.addEventListener('DOMContentLoaded', function() {
jQuery(document).ready(function() {
    jQuery('.mega-menu-right-img').appendTo('.tt-desctop-menu .tt-col-list');
});
jQuery(document).ready(function() {
    jQuery('.pro-whatapp-icon').appendTo('.tt-product-single-info .product-information-buttons');
});
});


  setInterval(function() {
    if ($(window).width() < 576) {
    jQuery(document).ready(function() {
      jQuery('.mobile_banner .tp-bgimg.defaultimg').remove();
    });
    }
  }, 100);